// Amounts arrive as integer puls (AFA x 100) and are only divided for display; the page never adds
// amounts together.
const afa = new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatPuls = (puls: number) => afa.format(puls / 100);
